export function validateUserPhoneNumber(phoneNumber, country_code) {
  if (country_code && country_code.toLowerCase() === 'in')
    return phoneNumber && phoneNumber.length == 10;
  return phoneNumber && phoneNumber.length >= 5 && phoneNumber.length <= 13;
}
